import { RepairList } from './views';

export default {
  list: RepairList,
  name: 'job-repair-sheet',
  label: 'Repairs',
  to: '/job-repair-sheet',
};
